export default __webpack_public_path__ + "static/media/RTR 200 FI_LateralIzq.0fc81fc5.webp";